import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, userReviews, fetchUserReviewsError } = props;

  const hasListingReviews = reviews && reviews.length > 0;
  const hasUserReviews = userReviews && userReviews.length > 0;
  const hasAnyReviews = hasListingReviews || hasUserReviews;

  if (!hasAnyReviews) {
    return null;
  }

  return (
    <section className={css.sectionReviews}>
      {hasListingReviews && (
        <div>
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
          </Heading>
          {fetchReviewsError ? (
            <H2 className={css.errorText}>
              <FormattedMessage id="ListingPage.reviewsError" />
            </H2>
          ) : null}
          <Reviews reviews={reviews} />
        </div>
      )}

      {hasUserReviews && (
        <div>
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            <FormattedMessage 
              id="ListingPage.providerReviewsTitle" 
              values={{ count: userReviews.length }} 
            />
          </Heading>
          {fetchUserReviewsError ? (
            <H2 className={css.errorText}>
              <FormattedMessage id="ListingPage.reviewsError" />
            </H2>
          ) : null}
          <Reviews reviews={userReviews} />
        </div>
      )}
    </section>
  );
};

export default SectionReviews;
